module.exports = __webpack_public_path__ + "static/girl-horizontal-12a9d94c261b8e0fab6194abc0a3018a.svg";